import { Box, FormControl, IconButton, Input, Spinner, Text, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { ChatState } from '../../Context/ChatProvider'
import { ArrowBackIcon } from '@chakra-ui/icons'
import UpdateGroupChatModal from './UpdateGroupChatModal'
import axios from 'axios'
import '../../components/styles.css'
import { getSender, getSenderFull } from '../../config/ChatLogics'
import ProfileModal from './ProfileModal'
import ScrollableChat from './ScrollableChat'
import io from 'socket.io-client'
import Lottie, { } from 'react-lottie'
import animationData from '../../assets/typing-animation.json'

const ENDPOINT = "http://localhost:5000";
var socket, selectedChatCompare;

const SingleChat = ({ fetchAgain, setFetchAgain }) => {

  const { user, selectedChat, setSelectedChat, notification, setNotification } = ChatState()

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState();
  const [socketConnected, setSocketConnected] = useState(false);
  const [typing, setTyping] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const toast = useToast();


  const fetchMessages = async () => {
    if (!selectedChat) return;

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      setLoading(true)
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/message/${selectedChat._id}`, config)

      console.log(messages);
      setMessages(data);
      setLoading(false);

      socket.emit('join chat', selectedChat._id)

    } catch (error) {
      toast({
        title: "Error Occured",
        description: "Failed to load the chats",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  }
  useEffect(() => {
    socket = io(ENDPOINT);
    socket.emit("setup", user);
    socket.on("connected", () => {
      setSocketConnected(true)
    });
    socket.on("typing", () => setIsTyping(true));
    socket.on("stop typing", () => setIsTyping(false))
  }, [])
  const sendMessage = async (event) => {
    if (event.key === 'Enter' && newMessage) {
      socket.emit("stop typing", selectedChat._id)
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          }
        };
        setNewMessage("");
        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/message`, {
          content: newMessage,
          chatId: selectedChat._id,
        }, config);

        console.log(data);
        socket.emit("new message", data);
        setMessages([...messages, data]);
      } catch (error) {
        toast({
          title: "Error Occured",
          description: "Failed to send the message",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
      }
    }
  }


  const typingHandler = (e) => {
    setNewMessage(e.target.value);

    if (!socketConnected) return;

    if (!typing) {
      setTyping(true);
      socket.emit("typing", selectedChat._id);
    }

    let lastTypingTime = new Date().getTime();
    var timerLength = 3000;
    setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;

      if (timeDiff >= timerLength && typing) {
        socket.emit("stop typing", selectedChat._id);
        setTyping(false);
      }
    }, timerLength)
  }


  useEffect(() => {
    fetchMessages();
    selectedChatCompare = selectedChat;
  }, [selectedChat]);

  console.log(notification);

  useEffect(() => {
    socket.on("message recieved", (newMessageRecieved) => {
      if (!selectedChatCompare || selectedChatCompare._id !== newMessageRecieved.chat._id) {
        //notification
        if (!notification.includes(newMessageRecieved)) {
          setNotification([newMessageRecieved, ...notification])
          setFetchAgain(!fetchAgain);
        }
      }
      else {
        setMessages([...messages, newMessageRecieved]);
      }
    })
  })
  return (
    <>
      {
        selectedChat ? (
          <>
            <Text
              fontSize={{ base: "28px", md: "30px" }}
              pb={3}
              px={2}
              w={'100%'}
              fontFamily={'sans-serif'}
              display={'flex'}
              justifyContent={{ base: "space-between" }}
              alignItems={"center"}
              color={'black'}
            >
              <IconButton
                display={{ base: "flex", md: "none" }}
                icon={<ArrowBackIcon />}
                onClick={() => { setSelectedChat("") }}
              />
              {!selectedChat.isGroupChat ? (
                <>
                  {getSender(user, selectedChat.users)}
                  <ProfileModal user={getSenderFull(user, selectedChat.users)} />
                </>
              ) : (
                <>
                  {
                    selectedChat.chatName.toUpperCase()
                  }
                  <UpdateGroupChatModal
                    fetchAgain={fetchAgain}
                    setFetchAgain={setFetchAgain}
                    fetchMessages={fetchMessages}
                  />
                </>
              )}
            </Text>
            <Box
              display={'flex'}
              flexDir={'column'}
              justifyContent={'flex-end'}
              p={3}
              bg={'rgba(0, 15, 0, 1)'}
              color={'white'}
              width={'100%'}
              height={'90%'}
              borderRadius={'lg'}
              overflowY={'hidden'}
            >

              {
                loading ? (
                  <Spinner
                    size={'xl'}
                    w={20}
                    h={20}
                    alignSelf={'center'}
                    margin={'auto'} />
                ) : (
                  <div className='messages'>
                    <ScrollableChat messages={messages} />
                  </div>
                )
              }

              <FormControl onKeyDown={sendMessage}
                isRequired mt={3}>
                {
                  isTyping ? <div>
                    <Lottie
                      options={defaultOptions}
                      width={70}
                      style={{ marginBottom: 5, marginLeft: 0 }}
                    />
                  </div> : <></>
                }
                <Input
                  variant={'filled'}
                  bg={'white'}
                  placeholder='Enter the Message..'
                  onChange={typingHandler}
                  value={newMessage}
                />

              </FormControl>
            </Box>
          </>
        ) : (
          <Box display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            h={'100%'}>
            <Text
              fontSize={'3xl'}
              pb={3}
              fontFamily={'Work sans'}
              color={'black'}>
              Click on the user to start chatting..
            </Text>
          </Box>
        )
      }
    </>
  )
}

export default SingleChat
